import React, {createContext, useContext, useEffect, useReducer} from 'react'

import {featureReducer, initialState} from './Features.reducer'
import {FeaturesDispatch, FeaturesState, FeaturesProviderProps} from './Features.types'
import {fetchFeatures} from './Features.action'

const FeaturesStateContext = createContext<FeaturesState | undefined>(undefined)
const FeaturesDispatchContext = createContext<FeaturesDispatch | undefined>(undefined)

export const FeaturesProvider = ({children, isLoggedOut}: FeaturesProviderProps) => {
  const [state, dispatch] = useReducer(featureReducer, initialState)

  useEffect(() => {
    if (!isLoggedOut)
      void fetchFeatures(dispatch)
  }, [dispatch])

  return (
    <FeaturesStateContext.Provider value={state}>
      <FeaturesDispatchContext.Provider value={dispatch}>
        {children}
      </FeaturesDispatchContext.Provider>
    </FeaturesStateContext.Provider>
  )
}

export const useFeaturesState = () => {
  const context = useContext(FeaturesStateContext)
  if (context === undefined) {
    throw new Error('useFeaturesState should be used within provider')
  }
  return context
}

export const useFeaturesDispatch = () => {
  const context = useContext(FeaturesDispatchContext)
  if (context === undefined) {
    throw new Error('useFeaturesState should be used within provider')
  }
  return context
}
